import { withRouter } from "react-router-dom";
import React, { Component } from 'react';
import { db, getNeighbourhoodId } from "../firebase/firebase";
import firebase from 'firebase/app';
import 'firebase/functions';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import ReCAPTCHA from 'react-google-recaptcha';
import { showSnackbar, showSnackbarWithType } from '../components/Snackbar.js';
import ThankYou from '../components/ThankYou';
import RoleUtils from '../utils/RoleUtils';
import PasswordUtils from '../utils/PasswordUtils';

import RegisterForm from '../components/Register/RegisterForm';

let captcha;

const phoneUtil = PhoneNumberUtil.getInstance();

class Register extends Component {

	constructor(props) {
		super(props);
		this.state = {
			done: false,
			name: '',
			email: '',
			phoneNumber: '',
			e164PhoneNumber: '',
			neighbourhood: null,
			neighbourhoods: [],
			acceptedPrivacy: false,
			password: '',
			neighbourhoodId: null
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		const pathParts = window.location.pathname.split('/');
		if (pathParts.length >= 3 && pathParts[1] === 'register') {
			const neighbourhoodId = pathParts[2].replaceAll(' ', '').trim();
			this.setState({ neighbourhoodId });
		}
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleSubmit = async event => {
		event.preventDefault();

		let number = null;
		try {
			number = phoneUtil.parseAndKeepRawInput(this.state.phoneNumber, 'NL');
			if (!phoneUtil.isValidNumber(number)) {
				showSnackbarWithType('Vul een geldig telefoonnummer in.', 'error');
				return;
			}

			const e164PhoneNumber = phoneUtil.format(number, PhoneNumberFormat.E164);

			const neighbourhoodId = this.state.neighbourhoodId || getNeighbourhoodId();
			const checkUser = firebase.functions().httpsCallable('checkUser');
			const data = { email: this.state.email.trim(), phoneNumber: e164PhoneNumber, neighbourhoodId };

			const response = await checkUser(data);
			const exists = response.data;

			if (exists.userWithPhoneNumberExists) {
				showSnackbarWithType('Er bestaat al een gebruiker met dit telefoonnummer.', 'error');
				return false;
			} else if (exists.newUserWithPhoneNumberExists) {
				showSnackbarWithType('Er bestaat al een aanvraag voor een gebruiker met dit telefoonnummer.', 'error');
				return false;
			} else if (exists.userWithEmailExists) {
				showSnackbarWithType('Er bestaat al een gebruiker met dit emailadres.', 'error');
				return false;
			} else if (exists.newUserWithEmailExists) {
				showSnackbarWithType('Er bestaat al een aanvraag voor een gebruiker met dit emailadres.', 'error');
				return false;
			}

			this.setState({
				e164PhoneNumber
			});

			captcha.execute();
		} catch (e) {
			console.error('[Register.js] (handleSubmit) exception', e);
			showSnackbarWithType('Vul een geldig telefoonnummer in.', 'error');
		}

	}

	insertData = async () => {
		let { name, email, e164PhoneNumber, phoneNumber, neighbourhoodId } = this.state;

		if (neighbourhoodId) {
			try {
				await db.collection('neighbourhoods').doc(neighbourhoodId.trim()).collection('newUserRequests')
					.add({
						name: name.trim(),
						email: email.trim(),
						phoneNumber: e164PhoneNumber ? e164PhoneNumber.trim() : phoneNumber.trim()
					});

				this.setState({
					done: true,
					name: '',
					phoneNumber: '',
					e164PhoneNumber: '',
					email: ''
				});
			} catch (error) {
				console.error('Error created newUserRequest:', error);
				showSnackbarWithType('Er is iets fout gegaan.', 'error');
			};
		} else {
			showSnackbarWithType('Er is iets fout gegaan.', 'error');
		}

	}


	onCaptchaChange = (value) => {
		if (this.state.neighbourhoodId !== null) {
			console.log('Self registration, insert data');
			this.insertData();
			return;
		}
		this.addUser();
	}

	render() {
		if (this.state.neighbourhoodId === null && getNeighbourhoodId() === null) {
			return (
				<div className="container content">
					<div className="alert alert-danger" role="alert">
						Er is geen team opgegeven om je voor aan te melden. Ga naar de juiste link om je aan te melden, bijvoorbeeld via een uitnodiging van de coördinator van het team.
					</div>
				</div>
			)
		}
		if (!this.state.done) {
			return (
				<div className="container  content">

					<form onSubmit={this.handleSubmit} className="card mb-4 box-shadow" autocomplete="off">

						<div className="card-header">
							<h4 className="my-0 font-weight-normal">{this.state.neighbourhoodId ? 'Aanmelden als Teamlid' : 'Registreren Teamlid'}</h4>
						</div>

						<div className="card-body">
							<RegisterForm
								name={this.state.name}
								phoneNumber={this.state.phoneNumber}
								email={this.state.email}
								password={this.state.password}
								handleInputChange={this.handleInputChange}
								neighbourhoodId={this.state.neighbourhoodId}
							/>
							<ReCAPTCHA
								ref={(el) => { captcha = el; }}
								size="invisible"
								sitekey="6LcI1k4UAAAAALe7Fp9GnzL9hcur0omO1KLCZedA"
								onChange={this.onCaptchaChange}
							/>
						</div>
					</form>
				</div>)
		} else if (this.state.done && this.state.neighbourhoodId === null) {
			return (
				<ThankYou />
			)
		} else {
			return (
				<div className="container content">
					<div className="alert alert-success" role="alert">
						Uw aanmelding is succesvol verzonden. U ontvangt een e-mail zodra uw account is verwerkt door de beheerder van het team, in dat email staat een link om uw wachtwoord in te stellen.
					</div>
				</div>
			)
		}
	}

	addUser() {
		const { name, email, e164PhoneNumber, password } = this.state;

		console.log(this.state);

		if (!PasswordUtils.isPasswordValid(password)) {
			showSnackbarWithType('Wachtwoord voldoet niet aan de eisen.', 'error');
			return;
		}

		showSnackbar('Gebruiker proberen toevoegen, een moment geduld aub...');

		const neighbourhoodId = getNeighbourhoodId();
		const createUser = firebase.functions().httpsCallable('createUser');
		createUser({
			email: email,
			displayName: name,
			password: password,
			phoneNumber: e164PhoneNumber,
			neighbourhoodId
		})
			.then(async userRecord => {
				await db.collection('users').doc(userRecord.data.uid).set({
					displayName: name,
					email: email,
					phoneNumber: e164PhoneNumber,
					uid: userRecord.data.uid,
					neighbourhoods: [
						neighbourhoodId
					],
					roles: [
						RoleUtils.Roles.User
					]
				}, { merge: true });
				await db.neighbourhoodCollection('users').doc(userRecord.data.uid).set({
					uid: userRecord.data.uid,
					displayName: name,
					email: email,
					phoneNumber: e164PhoneNumber,
					roles: [
						RoleUtils.Roles.User
					]
				});

				this.setState({ done: true });
				showSnackbar('Gebruiker is als teamlid toegevoegd');
			})
			.catch((error) => {
				console.error("Error creating user: ", JSON.stringify(error));
				showSnackbarWithType('Er is iets fout gegaan, probeer het nog een keer.', 'error');
			});
	}
}

export default withRouter(Register);

export {
	Register
};
